@if (smsMessage) {
  <div>
    <ul class="list-group">
      <li class="list-group-item">
        <div class="row">
          <div class="col-sm-12 col-md-6">
            <div class="pt-2 pb-2">
              To:
              @for (element of smsMessage.to; track element; let isLast = $last) {
                <span class="user-email">
                  {{element}}{{isLast ? '' : ', '}}
                </span>
              }
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="pt-2 pb-2">
              Status: <strong>{{ smsMessage.status }}</strong>
            </div>
            <div class="pt-2 pb-2">
              Retry Count: <strong>{{ smsMessage.retryCount }}</strong>
            </div>
            @if (smsMessage.status === 'Sent') {
              <div class="pt-2 pb-2">
                Date Sent: <strong>{{ smsMessage.messageSentOn | date:'short' }}</strong>
              </div>
            }
          </div>
        </div>
      </li>
      <li class="list-group-item message-body">
        <div>
          Message Body: <strong>{{ smsMessage.body }}</strong>
        </div>
      </li>
    </ul>
  </div>
}
